import { render } from "./TableDisplay.vue?vue&type=template&id=0569a222&scoped=true"
import script from "./TableDisplay.vue?vue&type=script&lang=js"
export * from "./TableDisplay.vue?vue&type=script&lang=js"

import "./TableDisplay.vue?vue&type=style&index=0&id=0569a222&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0569a222"],['__file',"src/views/HistoricalData/DiagnosisReport/components/TableDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0569a222"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0569a222', __exports__)) {
    api.reload('0569a222', __exports__)
  }
  
  module.hot.accept("./TableDisplay.vue?vue&type=template&id=0569a222&scoped=true", () => {
    api.rerender('0569a222', render)
  })

}


export default __exports__